var React = require('react');

function Zoom (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M14.9,12.6c-0.2,0-0.4-0.1-0.6-0.2l-2.6-2.1c-0.1-0.1-0.2-0.3-0.2-0.4V6.1c0-0.2,0.1-0.3,0.2-0.4l2.6-2.1\n\t\tc0.2-0.2,0.4-0.2,0.7-0.2c0.2,0,0.4,0.1,0.6,0.3c0.1,0.1,0.3,0.3,0.3,0.5C16,4.4,16,4.6,16,4.9v6.3c0,0.2,0,0.4-0.1,0.6\n\t\tc-0.1,0.2-0.2,0.4-0.3,0.5C15.4,12.5,15.2,12.6,14.9,12.6C14.9,12.6,14.9,12.6,14.9,12.6z"})),React.createElement("g",{"key":1},React.createElement("path",{"d":"M8.7,13.5H2.2c-1.2,0-2.2-1-2.2-2.2V4.7c0-1.2,1-2.2,2.2-2.2h6.6c1.2,0,2.2,1,2.2,2.2v6.6C10.9,12.5,9.9,13.5,8.7,13.5z"}))]);
}

Zoom.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Zoom;

Zoom.default = Zoom;
